import { reactTableConstant } from "./constants";

export const setFilters = (payload) => async (dispatch, getState, api) => {
  dispatch({ type: reactTableConstant.SET_FILTER, payload: payload });
};
export const resetFilters = (key) => async (dispatch, getState, api) => {
  dispatch({ type: reactTableConstant.RESET_FILTER, payload: key });
};
